import React, { useState, useEffect } from 'react';
import axios from "axios";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import API from '../api';


function Login() {
  const [values, setValues] = useState({ email: '', password: '' });
  const [message, setMessage] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedPlan = location.state?.selectedPlan;
  const [subscription, setSubscription] = useState(null);
  const [expiry_date, setExpiryDate] = useState('');
  const [start_date, setStartDate] = useState('');
  const [status, setStatus] = useState('');
  const [subscriptionStatus, setSubscriptionStatus] = useState();
  
  
    const formatDate = (datetime) => {
    const date = new Date(datetime);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
    };
  
useEffect(() => {
  document.title = "Login | TradeBarta.com";
}, []);


    async function handleSubmit(e) {
    e.preventDefault();

    try {
      const res = await API.post('/login', values, { withCredentials: true });
      setMessage(res.data.message);
      console.log("Login response:", res.data.message);

      login(res.data.user);
//      localStorage.setItem("user", JSON.stringify(res.data.user));

      // Redirect based on selected pricing plan
      if (selectedPlan) {
        const planName = selectedPlan.name;

        if (planName === 'Platinum') {
          navigate('/contact_us');
        } else if (planName === 'Free Trial') {
          navigate('/Dashboard');
        } else {
          navigate('/payment', { state: { selectedPlan } });
        }

        return;
      }
  //    console.log(res.data.user.id );
      // Fallback logic based on existing package in DB
      const response = await API.get('/packageid', {
        params: { user_id: res.data.user.id 
          
        }
      });

      const currentDate = new Date();      
      setStartDate(formatDate(response.data.start_date) || '');   
      setExpiryDate(formatDate(response.data.expiry_date) || '');
      setSubscriptionStatus(response.data.subscriptionStatus);

      const expiry = new Date(formatDate(response.data.expiry_date));
      
      navigate('/Dashboard'); 
     
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.error || 'Login failed');
    }
  }

  return (
    <div className="page-container">
      <div className="content-wrap">
      <section className="navbar-area navbar-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <nav className="navbar navbar-expand-lg">
                <a className="navbar-brand" href="/">
                  <img width="200" height="70" src={require("../images/logo.png")} alt="Logo" />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarOne"
                  aria-controls="navbarOne" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="toggler-icon"></span>
                  <span className="toggler-icon"></span>
                  <span className="toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse sub-menu-bar" id="navbarOne">
                  <ul className="navbar-nav m-auto">
<li className="nav-item">
                  <a className="active page-scroll" href="/">Home</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/pricing">Pricing</a>
                </li>
                
                <li className="nav-item">
                  <a className="page-scroll" href="/referral">Refer and Win</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/faq">FAQ</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/contact">Contact Us</a>
                </li>             
              </ul>
                </div>
                <div className="navbar-btn">
                  <ul className="list-unstyled d-flex flex-wrap flex-md-row gap-2">
                    <li>
                      <a className="btn btn-primary w-100 w-md-auto" href="/signup">SIGN UP</a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section id="hero-area" className="header-area header-ten">
        <div className="header-inner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 co-12">
                <div className="home-slider">
                  <div className="form-container">
                    <h1>Login</h1>

                    <form onSubmit={handleSubmit}>
                      <div>
                        <label htmlFor='email'>Email</label>
                        <input type='email' name='email' required onChange={(e) => setValues({ ...values, email: e.target.value })} />
                      </div>
                      <div>
                        <label htmlFor='password'>Password</label>
                        <input type='password' name='password' required onChange={(e) => setValues({ ...values, password: e.target.value })} />
                      </div>
                      <div>
                        <button type='submit'>Login</button>
                      </div>
                    </form>

                    {message && <p>{message}</p>}

                    <div className="form-footer">
                      Don't have an account? <a href="/signup">Sign Up Here</a>
                    </div>
                    <div className="form-footer">
                      <a href="/forgot_password">Forgot Password?</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

</div>
<section className="footer-area footer-five">
  <div className="container">
    <div className="footer-top-content">
      
      {/* Links Section */}
      <div className="footer-links">
        <ul>
          <li>
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>
          </li>
          <li>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>

      {/* Contact Section */}
      <div className="footer-contact">
        <h4>Contact Us:</h4>
        <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>
      </div>

    </div>
  </div>

  {/* Bottom copyright section */}
  <div className="footer-copyright">
    <div className="container">
      <p className="text-center">Copyright © 2025. All Rights Reserved</p>
    </div>
  </div>
</section>
    </div>
    
  );
}

export default Login;
